import warning from 'warning';
import { lightShadows, darkShadows, unsupportedShadow } from '@jpmuitk/style';
var MUIExpectedShadowCount = 25;
var supportedShadows = {
  light: lightShadows,
  dark: darkShadows
};

var defaultCreateShadow = function defaultCreateShadow(_ref) {
  var type = _ref.type,
      index = _ref.index;

  if (index >= supportedShadows[type].length) {
    return unsupportedShadow;
  }

  return supportedShadows[type][index];
};
/**
 * Create a shadow palette
 * Currently supported palettes are (light/dark)
 *
 * @param {string} type - type of shadow palette (light/dark)
 * @param {function} createShadow - callback to create shadow in palette
 */


export var createShadows = function createShadows() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  var createShadow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCreateShadow;

  if (process.env.NODE_ENV !== 'production') {
    warning(supportedShadows[type], "JPM-UI-Toolkit: the shadow type `".concat(type, "` is not supported."));
  }

  var shadowPalette = [];

  for (var shadowIndex = 0; shadowIndex < MUIExpectedShadowCount; shadowIndex++) {
    shadowPalette[shadowIndex] = createShadow({
      type: type,
      index: shadowIndex,
      value: defaultCreateShadow({
        type: type,
        index: shadowIndex
      })
    });
  }

  return shadowPalette;
};